import { forwardRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export type ChartProps = {
  options: Highcharts.Options;
  id?: string;
};

export const Chart = forwardRef<HighchartsReact.RefObject, ChartProps>(
  function ({ options, id }, ref) {
    return (
      <HighchartsReact
        ref={ref}
        highcharts={Highcharts}
        options={{ id, ...options }}
        id={id}
      />
    );
  },
);

Chart.displayName = 'Chart';
